import { PropsWithChildren, useEffect, useReducer } from "react";
import { AudioActions } from "./audio-context.types";
import { AudioContext, defaultAudioContext } from "./audio-context";
import { AudioDispatchContext } from "./audio-dispatch-context";
import { audioReducer } from "./audio.reducer";
import type { IAudioProviderProps } from "./audio-context.types";

/**
 * Provider component for the audio states context.
 * @param {ReactNode} props.children - The child components.
 * @returns {JSX.Element} AudioProvider component.
 */
export const AudioProvider = ({ children }: PropsWithChildren<IAudioProviderProps>) => {
    const [audioStates, dispatch] = useReducer(audioReducer, defaultAudioContext);

    // Resetting the audio context when the component unmounts
    useEffect(() => {
        return () => {
            dispatch({ type: AudioActions.RESET_CONTEXT, payload: defaultAudioContext });
        };
    }, []);

    return (
        <AudioContext.Provider value={audioStates}>
            <AudioDispatchContext.Provider value={dispatch}>{children}</AudioDispatchContext.Provider>
        </AudioContext.Provider>
    );
};
